import { ReactComponent as HomeIcon } from "./home.svg";
import { ReactComponent as Activity } from "./activity.svg";
import { ReactComponent as Report } from "./report.svg";
import { ReactComponent as Task } from "./task.svg";
import { ReactComponent as Config } from "./config.svg";
import { ReactComponent as Analytics } from "./analytics.svg";

export const navIcons = {
  HomeIcon,
  Activity,
  Report,
  Task,
  Config,
  Analytics,
};
